class VersionNotesApi {
  async getPublishedVersionNotes() {
    const url = `${process.env.REACT_APP_API_URL}/api/version-notes`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();
    return result;
  }

  async getVersionNoteById(id) {
    const url = `${process.env.REACT_APP_API_URL}/api/version-notes/${id}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = await response.json();
    return result;
  }
}

export const versionNotesApi = new VersionNotesApi(); 